import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "penilaianTunjanganKhusus";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const penilaianTunjanganKhususCreate =
  "Kepegawaian/PenilaianTunjanganKhusus/create/";
export const penilaianTunjanganKhususList =
  "Kepegawaian/PenilaianTunjanganKhusus/list/";
export const penilaianTunjanganKhususListDetail =
  "Kepegawaian/PenilaianTunjanganKhusus/listDetail/";

export const penilaianTunjanganKhususUpdate =
  "Kepegawaian/PenilaianTunjanganKhusus/update/";
export const penilaianTunjanganKhususInactive =
  "Kepegawaian/PenilaianTunjanganKhusus/inactive/";
export const penilaianTunjanganKhususActive =
  "Kepegawaian/PenilaianTunjanganKhusus/active/";

// function aries
export const penilaianTunjanganKhususGenerate =
  "Kepegawaian/PenilaianTunjanganKhusus/generate/";

export const penilaianTunjanganKhususVerifikasi =
  "Kepegawaian/PenilaianTunjanganKhusus/verifikasi/";

export const masterWorkUnit = "Master/List/workUnit/";
export const listAtasan = "Kepegawaian/PenilaianTunjanganKhusus/listAtasan/";

export const exportExcel = "Kepegawaian/PenilaianTunjanganKhusus/exportExcel/";

// function create assestment
export const detailSpecialAllowance =
  "Kepegawaian/PenilaianTunjanganKhusus/detailSpecialAllowance/";
export const createSpecialAllowance =
  "Kepegawaian/PenilaianTunjanganKhusus/createSpecialAllowance/";
export const clearSpecialAllowance =
  "Kepegawaian/PenilaianTunjanganKhusus/clearSpecialAllowance/";
export const listComponent =
  "Kepegawaian/PenilaianTunjanganKhusus/listPenilaiain/";
export const listCriteria =
  "Kepegawaian/PenilaianTunjanganKhusus/listCriteria/";
export const detailBobot = "Kepegawaian/PenilaianTunjanganKhusus/detailBobot/";

// update position
export const penilaianTunjanganKhususListPosition =
  "Kepegawaian/PenilaianTunjanganKhusus/listPosition/";
export const penilaianTunjanganKhususUpdatePosition =
  "Kepegawaian/PenilaianTunjanganKhusus/updatePositionTunsus/";
export const penilaianTunjanganKhususDeleteData =
  "Kepegawaian/PenilaianTunjanganKhusus/deleteTunsus/";

// get penilian history
export const listPenilaianBefore =
  "Kepegawaian/PenilaianTunjanganKhusus/listPenilaianBefore/";

export const sendNotification =
  "Kepegawaian/PenilaianTunjanganKhusus/reminderNotificationPenilaian/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
